export type WorkflowMessage = {
    context: string;
    targets: string;
    message: string;
    connectionId?: string;
    productId: string;
}

export enum WorkflowMessageContext {
    GOVERNANCE_REPORT = 'GovernanceReport',
    DOCUMENT = 'Document',
    ANALYTICS = 'Analytics',
}

export enum WorkflowMessageTarget {
    DATA_REFRESH = 'DataRefresh',
    ERROR_MODAL = 'ErrorModal',
    SUCCESS_MODAL = 'SuccessModal',
}